export const PRODUCT = 'UTCOM';

export const notMyBusinessAnymore = [
  '^/investments/?$',
  '^/investments/(ipo|preipo|otc)/?$',
  '^/investments/open-investment.*$',
  '^/how-it-works.*$',
  '^/trading.*$',
  '^/partnership.*$',
  '^/account.*$',
].map((regexp) => new RegExp(regexp));
